import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as s, createElementBlock as n, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconVeryDissatisfied",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function h(e, i, r, _, g, t) {
  return s(), n("svg", {
    "aria-label": r.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--very-dissatisfied"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Very Dissatisfied",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...i[0] || (i[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M5.899 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.399 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm2.435-1.777a.5.5 0 0 1 .693-.14l.197.132a.5.5 0 0 0 .555-.001l.193-.13a.5.5 0 1 1 .556.832l-.193.129a1.5 1.5 0 0 1-1.664.003l-.198-.132a.5.5 0 0 1-.14-.693Zm4 0a.5.5 0 0 1 .693-.14l.197.132a.5.5 0 0 0 .555-.001l.193-.13a.5.5 0 1 1 .556.832l-.193.129a1.5 1.5 0 0 1-1.664.003l-.198-.132a.5.5 0 0 1-.14-.693ZM5.899 6a2.641 2.641 0 0 0-1.608.517c-.46.345-.78.836-.883 1.39a.5.5 0 0 0 .49.593h4a.5.5 0 0 0 .492-.592 2.268 2.268 0 0 0-.883-1.39A2.641 2.641 0 0 0 5.9 6Zm-.006 1a1.642 1.642 0 0 0-1.002.317 1.41 1.41 0 0 0-.201.183h2.418a1.409 1.409 0 0 0-.2-.183A1.642 1.642 0 0 0 5.904 7h-.012Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...i[1] || (i[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, f);
}
const D = /* @__PURE__ */ u(c, [["render", h]]);
export {
  D as default
};
//# sourceMappingURL=very-dissatisfied.js.map
